"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceRemovalPayload = exports.DeviceUpsertPayload = exports.DeviceQuery = exports.UserRemovalPayload = exports.UserUpsertPayload = exports.UserQuery = exports.StoredMetadata = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const field_1 = require("../../../openapi/field");
const metadata_fields_1 = require("../../shared/metadata-fields");
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Metadata.Schema';
/**
 * Same rules as the admin device payloads: each validator applies only when the
 * other serial number is absent, and the ACL needs at least one of them. Both
 * stay optional here because JSON Schema cannot express "at least one".
 */
const deviceIdentity = {
    deviceSerialNumber: (0, field_1.optionalString)('Device serial number (required unless manufacturingSerialNumber is set; min 2 characters). Takes precedence when both are supplied.'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Manufacturing serial number (required unless deviceSerialNumber is set). Resolved to a device id through the registry.'),
};
exports.StoredMetadata = Json.Record.annotations({
    identifier: `${exports.NAMESPACE}.StoredMetadata`,
    description: 'GET success data: the stored key/value map, or {} when nothing is stored',
});
exports.UserQuery = effect_1.Schema.Struct({
    filters: metadata_fields_1.filters,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserQuery`,
    description: 'Query parameters for the current user metadata (shared or per-application). The owner comes from the session.',
});
exports.UserUpsertPayload = effect_1.Schema.Struct({
    items: metadata_fields_1.items,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserUpsertPayload`,
    description: 'Add or overwrite metadata of the current user (shared or per-application). The owner comes from the session; ownerType is not a client field.',
});
exports.UserRemovalPayload = effect_1.Schema.Struct({
    items: metadata_fields_1.removalKeys,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserRemovalPayload`,
    description: 'Remove metadata keys of the current user (shared or per-application), or all keys when items has no positive length.',
});
exports.DeviceQuery = effect_1.Schema.Struct({
    deviceSerialNumber: (0, field_1.optionalString)('Device serial number. Not validated: a missing or unknown value is a 404. Takes precedence when both are supplied.'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Manufacturing serial number, used when deviceSerialNumber is absent. Resolved to a device id through the registry; one that matches no device is a 404.'),
    filters: metadata_fields_1.filters,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceQuery`,
    description: 'Query parameters for device metadata. The query is not validated; the access check needs at least one serial number.',
});
exports.DeviceUpsertPayload = effect_1.Schema.Struct({
    ...deviceIdentity,
    items: metadata_fields_1.items,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceUpsertPayload`,
    description: 'Add or overwrite device metadata. ownerType is not a client field.',
});
exports.DeviceRemovalPayload = effect_1.Schema.Struct({
    ...deviceIdentity,
    items: metadata_fields_1.removalKeys,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceRemovalPayload`,
    description: 'Remove device metadata keys, or all keys when items has no positive length.',
});
//# sourceMappingURL=schema.js.map